import { InitSearch } from "./index.js";
window.ArcteryxSearch = { init: InitSearch };
